/** A single beat in the onboarding tutorial. The mascot reads `text`
 *  out in a speech bubble and plays the matching `animation`. Steps
 *  are advanced manually by the user (Next button) so they can read
 *  at their own pace; nothing in the sim is paused. */
export type TutorialStep = {
  id: string;
  text: string;
  animation: "idle" | "walk" | "talk" | "wave" | "happy";
};

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: "welcome",
    text:
      "Hi! I'm Axie. Welcome to RealChem Sandbox — a tiny chemistry world you can paint, heat, and react.",
    animation: "wave",
  },
  {
    id: "pick-material",
    text:
      "Pick a material from the left panel — try sand, water, or oil — then drag on the canvas to paint it.",
    animation: "talk",
  },
  {
    id: "heat-tool",
    text:
      "Use the heat brush (the flame button) to warm things up. Water boils to steam, oil ignites, ice melts.",
    animation: "talk",
  },
  {
    id: "shapes",
    text:
      "Below the materials you'll find shapes — torches, walls, switches. Tap one and stamp it on the grid.",
    animation: "talk",
  },
  {
    id: "formulas",
    text:
      "Open the right panel to write LaTeX-style formulas like '2 hydrogen + oxygen -> 2 water' and run them.",
    animation: "talk",
  },
  {
    id: "go-play",
    text: "That's it — press space to pause, C to clear. Have fun!",
    animation: "happy",
  },
];

const STORAGE_KEY = "realchem.tutorial.seen.v1";

export function hasSeenTutorial(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markTutorialSeen(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    // No-op: private browsing modes may block writes; that just
    // means the tutorial reappears next session, which is fine.
  }
}
